export default __webpack_public_path__ + "static/media/award1.3de832d5.jpeg";